export default __webpack_public_path__ + "static/media/login-button.9d9c81c1.png";